<template>
    <div class="about" style="background-color: #ffffff;min-height: 100%;">
        <div style="text-align: left;padding-top: 32px;padding-left: 16px;" class="in-bl-line">
            <div style="" class="in-bl-v-m">
              <!-- <van-image
                  round
                  width="83px"
                  height="83px"
                  :src="header_img"
              /> -->
              <img
                  round
                  style="width: 83px;height: 83px;"
                  src="../assets/images/logo.png"
                />
            </div>
            <div style="text-align: center;margin-left: 24px;" class="in-bl-v-m" v-if="!isLogin">
              <div style="font-size: 15px;color: #333;line-height: 24px;">登录后享受更多优惠及服务</div><br/>
              <van-button round type="info" style="background: #f25422;border: none;" @click="goLogin">登录/注册</van-button>
            </div>

           <div style="text-align: center;margin-left: 24px;" class="in-bl-v-m">
            <div style="font-size: 16px;color: #f25422;line-height: 24px;font-weight: bold;">{{info.uid}}</div>

            <div style="margin-top: 10px;">
              <van-button @click="loginOut">退出登录</van-button>
              <van-button style="margin-left: 14px;" @click="resetPassword">修改密码</van-button>
            </div>
          </div> 

        </div>

      <div class="barrie-line" style="margin-top: 40px"></div>

        <div   class="form-info-panel" style="padding-left: .4rem;text-align: left;">


          <!-- <div class="cus-row cus-row-v-m" @click="goCommonQue">
            <div class="cus-row-col-4"><span class="input-tag">修改密码</span></div>
            <div class="cus-row-col-8 select-line2">
              <input placeholder="" onfocus="this.blur()" readonly="readonly" class="line-input2">
            </div>
          </div> -->

          <div class="barrie-line" v-if="isLogin && false"></div>

          <div class="cus-row cus-row-v-m" @click="goCommonQue" v-if="isLogin && false">
            <div class="cus-row-col-4"><span class="input-tag">查看历史</span></div>
            <div class="cus-row-col-8 select-line2">
              <input placeholder="" onfocus="this.blur()" readonly="readonly" class="line-input2">
            </div>
          </div>


        </div>


      <tar-bar @showqr="showqr"></tar-bar>


    </div>
</template>

<script>
import common from '../assets/js/common'
import { getMe } from '../assets/js/api'
import TarBar from '../components/TarBar';

    export default {
        name: 'HelloWorld',
        props: {
            msg: String
        },
        components:
            {
              TarBar
            },
        data: function(){
            return {
                roleCn:'',
                phone:'',
                isLogin: false,
                info: {},
                header_img: '',
               user: {}
            }
        },
        methods:{
            goLogin()
            {
              this.$router.push({path: '/auth'})
            },
            goAbout()
            {
              this.$router.push({path: '/about', query:{type: 'about'}})
            },
            goSafe()
            {
              this.$router.push({path: '/about', query:{type: 'safe_ensure'}})
            },
            goCommonQue()
            {
              this.$router.push({path: 'common_que'})
            },
            initPage:function()
            {
                this.isLogin = common.getAuth()?common.getAuth():''
                if (!this.isLogin) {
                  return
                }
                getMe().then((res) => {
                  if (res.code == 0) {
                    this.info.uid = res.result.name
                    this.user = res.result
                  }
                })
            },
            loginOut:function()
            {
                common.setAuth('')
                this.$router.push({path: 'auth'})
            },
            resetPassword:function()
            {
                this.$router.push('reset_password')
            }
        },
        created:function()
        {
            /**
             * 如果没有token则跳到登录页哟
             */
            common.checkToken(this)

            common.setTitle('个人中心');
            this.id = common.queryValue('id');
        },
        mounted()
        {
            this.initPage();
        },
        onShow()
        {
        },
        computed:{
        }
    }
</script>

<style scoped>
    .fs-14-fc-ffffff
    {
        color: #ffffff;;
        font-size: 0.4375rem;
        font-family: PingFangSC-Medium;
        line-height: 0.525rem;
    }
</style>
